import { Foto } from './../model/foto';
import { Injectable } from '@angular/core';
import { Service } from './service.service';

@Injectable()
export class FotosCampanhaService extends Service<Foto> {

  protected getTable() {
    return 'fotosCampanha';
  }

  ultimas() {
    return super.ultimas(3);
  }

  protected getPageMax() {
    return 30;
  }

  public delete(id) {
    this.deleteFile(id);
    return super.delete(id);
  }

}



// WEBPACK FOOTER //
// ./src/app/service/fotos-campanha.service.ts